import AboutComponent from "../Components/AboutComponent";

const AboutPage = () => {
  return (
    <div>
      <AboutComponent />
    </div>
  );
}

export default AboutPage;